const formatRUT = (input: string): string => {
    const cleanInput = input.replace(/[^0-9kK]/g, '').toUpperCase();
    if (cleanInput.length <= 1) return cleanInput;
  
    const body = cleanInput.slice(0, -1).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    const checkDigit = cleanInput.slice(-1);
    return `${body}-${checkDigit}`;
  };

export default formatRUT;